export default "__VITE_ASSET__BPC5wCrS__"